import { getVisibleNavigationItems, VisibilityAwareNavigationItem } from '../../features/profile/navigationVisibility';
import { Profile } from '../../features/profile/types';
import { SectionVisibilityConfig } from '../../helpers/permissionHelper';
import { NAVIGATION_ROUTES } from '../../routes/NavigationRoute';

export type ProfileTabKey = 'projects' | 'roles' | 'profile' | 'paymentMethods' | 'subscription';

export interface ProfileTabDefinition extends VisibilityAwareNavigationItem {
    key: ProfileTabKey;
    name: string;
    route: string;
    visibility?: SectionVisibilityConfig | null;
}

export const PROFILE_TABS: ProfileTabDefinition[] = [
    // { key: 'paymentMethods', name: 'Payment methods', route: NAVIGATION_ROUTES.PROFILE_PAYMENT_METHODS },
    // { key: 'subscription', name: 'Subscription', route: NAVIGATION_ROUTES.PROFILE_SUBSCRIPTION },
    { key: 'profile', name: 'Profile', route: NAVIGATION_ROUTES.PROFILE },
    { key: 'projects', name: 'Projects', route: NAVIGATION_ROUTES.PROFILE_PROJECTS },
    { key: 'roles', name: 'Roles', route: NAVIGATION_ROUTES.PROFILE_ROLES }
];

export function getVisibleProfileTabs(profile: Profile | null | undefined): ProfileTabDefinition[] {
    return getVisibleNavigationItems(profile, PROFILE_TABS);
}
